import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
interface ChartProps {
  title: string;
  data: any[];
  type: 'bar' | 'pie';
  height?: number;
  xAxisLabel?: string;
  yAxisLabel?: string;
}
const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff8042', '#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
export const Chart: React.FC<ChartProps> = ({
  title,
  data,
  type,
  height = 300,
  xAxisLabel,
  yAxisLabel
}) => {
  if (type === 'bar') {
    // Extract keys excluding 'name'
    const keys = Object.keys(data[0] || {}).filter(key => key !== 'name');
    return <div data-id="element-14530">
        {title && <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-14531">
            {title}
          </h3>}
        <div style={{
        height: `${height}px`
      }} data-id="element-14532">
          <ResponsiveContainer width="100%" height="100%" data-id="element-14533">
            <RechartsBarChart data={data} margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 40
          }} data-id="element-14534">
              <CartesianGrid strokeDasharray="3 3" data-id="element-14535" />
              <XAxis dataKey="name" label={xAxisLabel && xAxisLabel !== 'Segment' ? {
              value: xAxisLabel,
              position: 'insideBottom',
              offset: -20
            } : undefined} data-id="element-14536" />
              <YAxis label={yAxisLabel ? {
              value: yAxisLabel,
              angle: -90,
              position: 'insideLeft'
            } : undefined} data-id="element-14537" />
              <Tooltip data-id="element-14538" />
              <Legend data-id="element-14539" />
              {keys.map((key, index) => <Bar key={key} dataKey={key} fill={COLORS[index % COLORS.length]} data-id="element-14540" />)}
            </RechartsBarChart>
          </ResponsiveContainer>
        </div>
      </div>;
  } else if (type === 'pie') {
    return <div data-id="element-14541">
        {title && <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-14542">
            {title}
          </h3>}
        <div style={{
        height: `${height}px`
      }} data-id="element-14543">
          <ResponsiveContainer width="100%" height="100%" data-id="element-14544">
            <PieChart data-id="element-14545">
              <Pie data={data} cx="50%" cy="50%" labelLine={true} label={({
              name,
              percent
            }) => `${name}: ${(percent * 100).toFixed(0)}%`} outerRadius={80} fill="#8884d8" dataKey="value" data-id="element-14546">
                {data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-14547" />)}
              </Pie>
              <Tooltip data-id="element-14548" />
              <Legend data-id="element-14549" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>;
  }
  return null;
};